export default {
    padding: 1,
    radius: 0.35,
};
